import script from "./StripeIntegrationRequired.vue?vue&type=script&setup=true&lang=js"
export * from "./StripeIntegrationRequired.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import SignupMainContainer from "@/components/signup/SignupMainContainer.vue";
script.components = Object.assign({}, { SignupMainContainer }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { SignupMainContainer }, script.__o.components);}